import { createAction, props } from '@ngrx/store';
import { Proposal } from '@lockton-apps/shared/interfaces';
import { Quote } from '@lockton-apps/shared/interfaces';

export enum ProposalsApiActionTypes {
  BeginProposalSuccess = '[Proposals API] Begin Proposal Success',
  BeginProposalFailure = '[Proposals API] Begin Proposal Failure',

  LoadProposalSuccess = '[Proposals API] Load Proposal Success',
  LoadProposalFailure = '[Proposals API] Load Proposal Failure',

  SaveProposalSuccess = '[Proposals API] Save Proposal Success',
  SaveProposalFailure = '[Proposals API] Save Proposal Failure',

  SubmitStepSuccess = '[Proposals API] Submit Step Success',
  SubmitStepFailure = '[Proposals API] Submit Step Failure',

  SubmitProposalSuccess = '[Proposals API] Submit Proposal Success',
  SubmitProposalFailure = '[Proposals API] Submit Proposal Failure',
}

export const ProposalsApiActions = {
  beginProposalSuccess: createAction(
    ProposalsApiActionTypes.BeginProposalSuccess,
    props<{ proposal: Proposal }>()
  ),

  beginProposalFailure: createAction(
    ProposalsApiActionTypes.BeginProposalFailure,
    props<{ error: any }>()
  ),

  loadProposalSuccess: createAction(
    ProposalsApiActionTypes.LoadProposalSuccess,
    props<{ proposal: Proposal }>()
  ),
  loadProposalFailure: createAction(
    ProposalsApiActionTypes.LoadProposalFailure,
    props<{ error: any }>()
  ),

  saveProposalSuccess: createAction(
    ProposalsApiActionTypes.SaveProposalSuccess,
    props<{ proposal: Proposal }>()
  ),
  saveProposalFailure: createAction(
    ProposalsApiActionTypes.SaveProposalFailure,
    props<{ error: any }>()
  ),

  submitStepSuccess: createAction(
    ProposalsApiActionTypes.SubmitStepSuccess,
    props<{ proposal: Proposal }>()
  ),

  submitStepFailure: createAction(
    ProposalsApiActionTypes.SubmitStepFailure,
    props<{ error: any }>()
  ),

  submitProposalSuccess: createAction(
    ProposalsApiActionTypes.SubmitProposalSuccess,
    props<{ quotes: Quote[] }>()
  ),
  submitProposalFailure: createAction(
    ProposalsApiActionTypes.SubmitProposalFailure,
    props<{ error: any }>()
  ),
};
